import { LandingContainer } from "../containers/LandingContainer";

export function LandingPage() {

    return (
        <LandingContainer />
    );

}